module.exports = __webpack_public_path__ + "static/img/case_tab_05.e8dd967.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_tab_05.png
// module id = 84MK
// module chunks = 34